import { FieldInput } from 'components/fieldInput';
import { Form, Formik } from 'formik';
import React, { Fragment } from 'react';
import CustomLoader from 'components/CustomLoader';
import { EndorsementsTable } from '../components/EndorsementsTable';
import styles from '../styles.module.scss';

export function OtherEndorsement({
  validation,
  endorsements,
  changes,
  loading,
  setEndorsements,
  setStage,
  submit,
  submitting,
  resetModal
}) {
  return (
    <div className={styles.insideWrapper}>
      <div className={styles.title}>
        Other Endorsement
      </div>
      <div className={styles.line} />
      <Formik
        validationSchema={validation}
        initialValues={{
          instructions: '',
        }}
      >
        {({
          errors,
          touched,
          values,
          handleSubmit,
          handleChange,
          handleBlur,
          validateForm,
          setTouched,
        }) => (
          <Fragment>
            <Form
              className={styles.form}
              onSubmit={handleSubmit}
              style={{ marginTop: 10 }}
            >
              <div className={styles.fieldRow} style={{ marginBottom: 10 }}>
                <FieldInput
                  id="instructions"
                  type="text"
                  label="Instructions"
                  placeholder="Please specify the details of your endorsement"
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  showErrors
                  errors={errors.instructions}
                  touched={touched.instructions}
                  required
                  fullWidth
                />
              </div>
            </Form>
            {endorsements.length > 0 && (
              <EndorsementsTable changes={changes} loading={loading} />
            )}
            <div
              className={styles.footer}
              style={{
                justifyContent: 'space-between',
              }}
            >
              <div className={styles.buttons}>
                <button
                  className={styles.cancel}
                  onClick={resetModal}
                >
                  Cancel
                </button>
              </div>
              <div className={styles.buttons}>
                <button
                  className={styles.save}
                  style={{
                    marginRight: 10,
                    marginLeft: 10,
                    width: '240px',
                  }}
                  onClick={async () => {
                    setTouched({
                      instructions: true,
                    });

                    if (values.instructions !== '') {
                      const validation = await validateForm(values);

                      if (Object.values(validation).length === 0) {
                        setEndorsements((prev) => [
                          ...prev,
                          {
                            type: 'other_endorsement',
                            value: values.instructions,
                          },
                        ]);

                        setStage('select_endorsement_type');
                      }
                    } else {
                      setStage('select_endorsement_type');
                    }
                  }}
                >
                  Add Another Change
                </button>
                <button
                  className={styles.save}
                  style={{ width: '330px' }}
                  onClick={async () => {
                    setTouched({
                      instructions: true,
                    });

                    if (values.instructions !== '') {
                      const validation = await validateForm(values);

                      if (Object.values(validation).length === 0) {
                        submit([
                          ...endorsements,
                          {
                            type: 'other_endorsement',
                            value: values.instructions,
                          },
                        ]);
                      }
                    } else {
                      submit(endorsements);
                    }
                  }}
                >
                  {submitting ? (
                    <div
                      style={{
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <CustomLoader />
                    </div>
                  ) : (
                    'Finish and Submit Endorsement'
                  )}
                </button>
              </div>
            </div>
          </Fragment>
        )}
      </Formik>
    </div>
  );
}
